<template>
    <div class="main">
        <c-panel>
            <tabulacao-form
                tipo="DESENHO"
                :turma-id="$route.params.turmaId"
                :periodo-id="$route.params.periodoId"
                voltar-para="/admin/tabulacao/professor/desenho">
            </tabulacao-form>
        </c-panel>
    </div>
</template>

<script>
import TabulacaoForm from '@/components/tabulacao/shared/tabulacao-form.vue'

export default {
    components: { TabulacaoForm }
}
</script>
